import {
  Component,
  OnInit,
  Output,
  EventEmitter,
  Input,
  OnDestroy,
} from '@angular/core';
import { HttpService } from 'src/app/services/http.service';
import { environment } from 'src/environments/environment';
import { CalendarService } from '../../services/calendar.service';
import { Subscription } from 'rxjs';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-operators',
  templateUrl: './operators.component.html',
  styleUrls: ['./operators.component.scss'],
})
export class OperatorsComponent implements OnInit, OnDestroy {
  @Output() emitOperator = new EventEmitter();
  @Input() service = undefined;
  @Input() serviceId = this.route.snapshot.paramMap.get('id');
  public page = 1;
  public operators: any[] = [];
  public operator = undefined;
  public length = 0;
  private _domainId = environment.domainId;
  private _calendarSubs: Subscription = new Subscription();
  private _routeSubs: Subscription = new Subscription();
  private _operatorId?: number;

  constructor(
    private httpSv: HttpService,
    private calendarSv: CalendarService,
    private route: ActivatedRoute
  ) {}

  ngOnInit() {
    this._routeSubs = this.route.queryParamMap.subscribe((params) => {
      const operatorId = params.get('operatorId');
      this._operatorId = +operatorId;
    });

    this.getOperators();
    this._calendarSubs = this.calendarSv.emitNewDate.subscribe((date) => {
      this.getOperator(this.operator, date);
    });
  }

  async getOperators() {
    try {
      this.operators = this.service.operators;
      this.length = this.operators.length;
      if (this.length === 1) {
        this.getOperator(this.operators[0]);
      }

      const operatorId = this._operatorId;
      if (operatorId) {
        const operator = this.operators.find((o) => +o.id === +operatorId);
        if (operator) {
          this.getOperator(operator);
        }
      }
    } catch (err) {
      console.error(err);
    }
  }

  async getOperator(operator, date?) {
    try {
      operator.serviceId = this.serviceId;
      const actualDate = date || new Date();
      const body = {
        operatorId: operator.id,
        domainId: this._domainId,
        date: JSON.stringify({
          month: actualDate.getMonth() + 1,
          year: actualDate.getFullYear(),
        }),
      };
      const res = await this.httpSv.itemIndex('operators', '', body);
      res.data.duration = this.service.duration; //minutos
      this.emitOperator.emit({
        operator,
        date: res.data,
        service: this.service,
        actualDate,
        length: this.operators.length === 1 ? false : true,
        minLength: this.operators.length,
      });
      this.operator = operator;
    } catch (err) {
      console.error(err);
    }
  }

  ngOnDestroy() {
    this._calendarSubs.unsubscribe();
    this._routeSubs.unsubscribe();
  }

  unSelect() {
    this.operator = undefined;
    this.emitOperator.emit({
      operator: undefined,
      length: this.operators.length === 1 ? false : true,
    });
  }
}
